import { AutogenModelCustomUiLayout, AutogenRowCustomUiLayout } from "./autogen/AutogenModelCustomUiLayout";

export class ModelCustomUiLayout extends AutogenModelCustomUiLayout<RowCustomUiLayout> {
    constructor() {
        super(RowCustomUiLayout);
    }
}

export class RowCustomUiLayout extends AutogenRowCustomUiLayout {
}